import { lazyWithPreload } from "utils/lazyWithPreload"
import { universalRoutes } from "./universal"

const Alerts = lazyWithPreload(() => import("pages/thirdRail/Alerts"))
const LiveThirdRailDevices = lazyWithPreload(() => import("pages/thirdRail/LiveThirdRailDevices"))

export const thirdRailRoutes = [
  {
    path: "/",
    component: LiveThirdRailDevices,
    meta: { breadcrumb: [{ parent: "Dashboard", label: "Live" }] },
  },
  {
    path: "/alerts",
    component: Alerts,
    meta: { breadcrumb: [{ parent: "Dashboard", label: "Alerts" }] },
  },
  ...universalRoutes,
]
